import React, { useEffect, useState } from "react";
import { useAppDispatch as useDispatch } from "src/core/redux/hooks";
import { appendBreadCrumb, selectTeamPackageList, setPageTitle } from "src/core/redux";
import { SentinelPageProps } from "../../interfaces";
import { SentinelBasePage } from "../sentinel-base";
import {
  Box,
  Button,
  Header,
  Icon,
  Link,
  Pagination,
  SpaceBetween,
  Table,
  TextFilter,
} from "@cloudscape-design/components";
import { getOnboardedTeams, getTeamPackageList } from "src/core/sentinel/actions";
import { SentinelController } from "src/core/controller";
import { OnboardedTeam, OnboardedTeamResponse, TeamPackageListResponse } from "src/core/sentinel/types";
import { on } from "events";
import { TeamPackage } from "@amzn/dependencysentinel";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
export interface SentinelTeamDetailPageProps extends SentinelPageProps {
  readOnly?: boolean;
  sentinelController: SentinelController;
}
export const TeamDetailPage: React.FC<SentinelTeamDetailPageProps> = (
  // eslint-disable-next-line
  props: SentinelTeamDetailPageProps
) => {
  const dispatch = useDispatch();
  const [packageList, setPackageList] = useState<TeamPackage[]>([]);
  const [loading, setLoading] = useState(true);
  const [filteringText, setFilteringText] = useState("");
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [teamPackageList, setTeamPackageList] = useState<TeamPackage[]>([]);
  const pageSize = 50;
  const teamPackageListFromRedux = useSelector(selectTeamPackageList).payload.teamPackageList;
  const { teamId } = useParams<{ teamId: string }>();
  useEffect(() => {
    const fetchTeamPackages = async () => {
      try {
        const response = await dispatch(
          getTeamPackageList({
            sentinelController: props.sentinelController,
          })
        );
        const teamPackageList = (response as TeamPackageListResponse)?.payload?.payload?.teamPackageList;
        setTeamPackageList(teamPackageList);
      } catch (error) {
        console.error(`Error for gettinng team pakcages: ${error}`, error);
      }
    };
    fetchTeamPackages();
  }, []);
  useEffect(() => {
    if (teamPackageListFromRedux && teamId) {
      const list = Object.values(teamPackageListFromRedux) as TeamPackage[];
      const filteredList = list.filter(item => item.teamName === teamId);
      setPackageList(filteredList);
    }
    setLoading(false);
  }, [teamPackageList]);

  const filteredPackages = packageList.filter((p) => {
    const content = [
      p.bindleId,
      p.packageName,
      p.teamName,
    ]
      .join(" ")
      .toLowerCase();

    return (
      !filteringText || content.includes(filteringText.toLowerCase())
    );
  });

  const paginatedItems = filteredPackages.slice(
    (currentPageIndex - 1) * pageSize,
    currentPageIndex * pageSize
  );

  const totalPages = Math.ceil(filteredPackages.length / pageSize);

  useEffect(() => {
    dispatch(setPageTitle("Team Detail"));
  }, []);

  return (
    <SentinelBasePage>
      <Table
        items={paginatedItems}
        columnDefinitions={[
            {
            id: "details",
            header: "Details",
          cell: (e) => (
            <Link
              variant="info"
              href={`#/team/details/${teamId}/${e.packageName}`}
            >
              <Button variant="link">
                <Icon name="edit" />
              </Button>
            </Link>
          ),
          },
          {
            id: "teamName",
            header: "Team Name",
            cell: (e: TeamPackage) => e.teamName,
            sortingField: "teamName",
            isRowHeader: true,
          },
          {
            id: "packageName",
            header: "Package Name",
            cell: (e: TeamPackage) => e.packageName,
            sortingField: "packageName",
            isRowHeader: true,
          },
          {
            id: "bindleId",
            header: "Bindle ID",
            cell: (e: TeamPackage) => e.bindleId,
            sortingField: "bindleId",
            isRowHeader: true,
          },
        ]}
        renderAriaLive={({ firstIndex, lastIndex, totalItemsCount }) =>
          `Displaying items ${firstIndex} to ${lastIndex} of ${totalItemsCount}`
        }
        loading={loading}
        loadingText="Loading resources"
        empty={
          <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
            <SpaceBetween size="m">
              <b>No package found</b>
            </SpaceBetween>
          </Box>
        }
        filter={
          <TextFilter
            filteringPlaceholder="Type any keyword to filter packages"
            filteringText={filteringText}
            onChange={({ detail }) => {
              setFilteringText(detail.filteringText);
              setCurrentPageIndex(1);
            }}
            countText={`${filteredPackages.length} matches`}
          />
        }
        header={<Header>Packages for Team: {teamId}</Header>}
        pagination={
          <Pagination
            currentPageIndex={currentPageIndex}
            pagesCount={totalPages}
            onChange={({ detail }) =>
              setCurrentPageIndex(detail.currentPageIndex)
            }
          />
        }
      />
    </SentinelBasePage>
  );
};
